import { useEffect, useState } from 'react';

function getSearchParams(search = window.location.search) {
  return new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
}

function getHashSearchParams(hash = window.location.hash) {
  if (!hash) {
    return new URLSearchParams();
  }

  const hashWithoutPrefix = hash.startsWith('#') ? hash.slice(1) : hash;
  const queryStartIndex = hashWithoutPrefix.indexOf('?');

  if (queryStartIndex === -1) {
    return new URLSearchParams();
  }

  return new URLSearchParams(hashWithoutPrefix.slice(queryStartIndex + 1));
}

function getMergedSearchParams() {
  const params = getSearchParams();
  const hashParams = getHashSearchParams();

  hashParams.forEach((value, key) => {
    if (!params.has(key)) {
      params.set(key, value);
    }
  });

  return params;
}

function getAuthParams() {
  const params = getMergedSearchParams();

  return {
    ekid: params.get('ekid'),
    enpd: params.get('enpd'),
    enfd: params.get('enfd'),
    cmac: params.get('cmac'),
    rid: params.get('rid'),
    p: params.get('p'),
    c: params.get('c'),
    m: params.get('m'),
    originalUrl: params.get('original_url'),
    cardType: params.get('type'),
  };
}

function hasAtLeastOneParam(values) {
  return Object.values(values).some(
    (value) => value !== null && value !== undefined,
  );
}

export function useAuthParams(intervalMs = 300) {
  const initialParams = getAuthParams();
  const initialHasParams = hasAtLeastOneParam(initialParams);

  const [authParams, setAuthParams] = useState(initialParams);
  const [hasParams, setHasParams] = useState(initialHasParams);

  useEffect(() => {
    if (hasParams) return undefined;

    const checkParams = () => {
      const nextParams = getAuthParams();

      if (hasAtLeastOneParam(nextParams)) {
        setAuthParams(nextParams);
        setHasParams(true);
      }
    };

    const interval = setInterval(checkParams, intervalMs);

    checkParams();

    return () => clearInterval(interval);
  }, [hasParams, intervalMs]);

  return {
    authParams,
    hasParams,
  };
}
